import { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { IoMdEye } from "react-icons/io";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import PrintRoundedIcon from "@mui/icons-material/PrintRounded";

//Import from project
import "../../Style/actionstyle.scss";
import Payment from "./Payment/Payment";
import ViewInvoice from "./View/ViewInvoice";
import PrintInvoice from "./Print/PrintInvoice";
import VoidInvoice from "./Void/VoidInvoice";
import useVoidInvoice from "./Void/useVoidInvoice";
import { AuthContext } from "../../Context/AuthContext";

export default function InvoiceAction({ editData, setRefetch }) {
  // Change Language
  const { t } = useContext(AuthContext);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal update
  const [openPrint, setOpenPrint] = useState(false);
  const handleOpenPrint = () => setOpenPrint(true);
  const handleClosePrint = () => setOpenPrint(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //Modal delete
  const [openView, setOpenView] = useState(false);
  const handleOpenView = () => setOpenView(true);
  const handleCloseView = () => setOpenView(false);

  const { handleDelete, loading } = useVoidInvoice({
    handleCloseDel,
    id: editData?._id,
    setRefetch,
  });

  return (
    <div>
      <Stack direction="row" alignItems="center" justifyContent="right">
        <Tooltip title={t("print")} placement="top">
          <IconButton onClick={handleOpenPrint}>
            <PrintRoundedIcon sx={{ color: "#287ADF" }} fontSize="medium" />
          </IconButton>
        </Tooltip>

        <Tooltip title={t("view")} placement="top">
          <IconButton onClick={handleOpenView}>
            <Box className="view-container">
              <IoMdEye className="view-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        {editData?.void || editData?.paymentStatus === "Paid" ? (
          ""
        ) : (
          <Tooltip title={t("payment")} placement="top">
            <IconButton onClick={handleOpenEdit}>
              <Box className="payment-container">
                <PaymentOutlinedIcon className="payment-icon" />
              </Box>
            </IconButton>
          </Tooltip>
        )}

        {!editData?.void && (
          <Tooltip title={t("void")} placement="top">
            <IconButton onClick={handleOpenDel}>
              <Box className="void-container">
                <BlockOutlinedIcon className="void-icon" />
              </Box>
            </IconButton>
          </Tooltip>
        )}
      </Stack>

      {openPrint && (
        <PrintInvoice
          open={openPrint}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleClosePrint}
        />
      )}

      {openEdit && (
        <Payment
          open={openEdit}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseEdit}
        />
      )}

      {openView && (
        <ViewInvoice
          open={openView}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseView}
        />
      )}

      {openDel && (
        <VoidInvoice
          open={openDel}
          loading={loading}
          handleClose={handleCloseDel}
          handleDelete={handleDelete}
        />
      )}
    </div>
  );
}
